'use client'

import { useCallback, useState } from 'react'

import Modal from '@/components/Modal/Modal'

import HelpCategoryContent from './HelpCategoryContent'
import { helpContent } from './helpContent'
import TutorialPlayerModal from './TutorialPlayerModal'
import { HelpTutorial, useTutorials } from './tutorials'

type GuidePlayerModalProps = {
  sectionId: string | null
  onClose: () => void
}

const GuidePlayerModal = ({ sectionId, onClose }: GuidePlayerModalProps) => {
  useTutorials()
  const [selectedTutorial, setSelectedTutorial] = useState<HelpTutorial | null>(null)
  const closeTutorial = useCallback(() => setSelectedTutorial(null), [])
  const category = sectionId
    ? helpContent.find((item) => item.sections.some((section) => section.id === sectionId))
    : undefined
  const section = category?.sections.find((item) => item.id === sectionId)

  return (
    <>
      <TutorialPlayerModal tutorial={selectedTutorial} onClose={closeTutorial} />
      <Modal
        isOpen={section !== undefined}
        onClose={onClose}
        title={section?.title}
        className="!p-0"
        closeOnOutsideClick={false}
      >
        {category && section && (
          <div className="max-h-[calc(100vh-220px)] w-[900px] max-w-[calc(100vw-80px)] overflow-y-auto p-xl">
            <HelpCategoryContent
              category={category}
              sectionIds={[section.id]}
              showCategoryHeader={false}
              showSectionHeader={false}
              onPlayTutorial={setSelectedTutorial}
            />
          </div>
        )}
      </Modal>
    </>
  )
}

export default GuidePlayerModal
